<div class="flex flex-col">
  <div class="notification-message-container w-p-100 m-0 m-b-20 " style="color: #3A416F!important;">
    <div>
      <span>Note:</span> Once you are finished with your review, you can confirm changes. If you are still waiting for
      further responses to this survey, you can keep this survey open. Otherwise if you choose to mark this survey as
      'Complete', no further responses can be submitted.
    </div>
  </div>
  <div *ngIf="data.input.warningMessage && data.input.warningMessage.length"
       class="notification-message-container warning w-p-100 m-0 m-b-20 ">
    <div>
      <span>Warning:</span> {{data.input.warningMessage}}
    </div>
  </div>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Status &nbsp;*</mat-label>
      <mat-select (selectionChange)="onSelectStatusChange()" [(ngModel)]="data.input.selectedStatusType">
        <mat-option *ngFor="let type of statusTypes" [value]="type.key">
          {{type.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Details</mat-label>
      <textarea matInput type="text" [(ngModel)]="data.input.message"
                rows="5">
              </textarea>
    </mat-form-field>
  </div>

</div>
